import * as React from 'react';
import type { FC } from 'react';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { QuickSignupFormProps, Values, ChangeValues } from './types';
import CountryIcon from './images/icon_geo.svg';

const Country: FC<{
  values: Values;
  changeValues: ChangeValues;
  countries: QuickSignupFormProps['countries'];
  locales: Locales;
}> = ({ values, changeValues, countries, locales }) => (
  <div className="player_country-wrap">
    <div className="country-title rs-text-align_center">{translation(locales, 'country.label')}</div>
    <div className="input player_country xo-form_select-iconfull">
      <div className="xo-form_select-wrap">
        <select
          id="player_country"
          name="player[country]"
          className="xo-form_select"
          onChange={(v) => changeValues({ country: v.target.value })}
          value={values.country}
        >
          {countries.map(([code, name]) => (
            <option value={code} key={code}>
              {name}
            </option>
          ))}
        </select>
        <label htmlFor="player_country" className="xo-form_select-label">
          <span className="xo-form_label-placeholder">{translation(locales, 'country.label')}</span>
          <span className="xo-form_input-image">
            <img src={CountryIcon} alt="icon" />
          </span>
        </label>
      </div>
    </div>
  </div>
);

export default Country;
